export const GAME_EVENTS = Object.freeze({
    // Game
    GAME_STARTED: "game_started",
    TURN_STARTED: "turn_started",

    // Card
    CARD_SELECTED: "card_selected",
    CARD_PLAYED: "card_played",
    CARD_DRAWN: "card_drawn",

    // Action
    FORWARD_MARCH: "forward_march",
    SHOT_RESOLUTION: "show_resolution",
    TARGET_ADDED: "target_added",
    TARGET_REMOVED: "target_removed",
    SWAP_DUCK: "swap_duck",
    BANZAI: "banzai",
    DISPERTION: "dispersion",
    PLANQUE: "planque",
    PROTECT_DUCK: "protect_duck",
    EXPOSE_DUCK: "expose_duck",
});